import React from "react";
import useModalStore from "../../zustandStores/useModalStore";
import PremiumPopup from "../PremiumPopup";
import ButtonGroup from "../ButtonGroup";
import { modalStateValues, PREMIUM_JOB } from "../../services/constants";
import PostJobView from "../PostJobView";
import { premiumJobLabel } from "../JobType/v2/constants";
import useJobPostingPayloadStore from "../../zustandStores/jobPostingPayloadStore";
import useSingleJobSkus from "../../zustandStores/singleJobSkus";
import useMetaLabels from "../../hooks/metaLabels";
import usePremiumJobCreditsBreakUp from "../../hooks/premiumJobCreditsBreakUp";
import { PerksDrawbackProps } from "components/JobType/v2/PerksDrawback";

const PostPremiumJob = (): JSX.Element => {
  const { modalData, setModalData } = useModalStore(state => ({
    modalData: state.modalData,
    setModalData: state.setModalData
  }));
  const { payload } = useJobPostingPayloadStore(state => ({
    payload: state.payload
  }));
  const { job_city_id: cityId = null, category_id: categoryId = null } =
    payload?.jobPostingData?.jobDetails || {};
  const { premiumSku } = useSingleJobSkus((state: any) => ({
    premiumSku: state.premiumSku
  }));
  const { isSpecialPrice } = usePremiumJobCreditsBreakUp({
    cityId,
    categoryId
  });
  const { cityId: metaCityId = null, categoryId: metaCategoryId = null } =
    premiumSku;
  const { cityLabel, categoryLabel } = useMetaLabels({
    cityId: metaCityId,
    categoryId: metaCategoryId
  });
  const { heading, state, callback, closeCallback, subHeading } = modalData;
  const { open } = modalStateValues;
  const isPopupOpen = state === open;
  const onClose = () => {
    setModalData({
      ...modalData,
      type: "",
      state: modalStateValues.CLOSE
    });
    if (closeCallback) closeCallback();
  };
  const defaultSubHeading = isSpecialPrice
    ? `${categoryLabel} jobs in ${cityLabel} are available at a special price.`
    : "";
  const popupSubHeading = subHeading ?? defaultSubHeading;
  const perksDrawbackList: PerksDrawbackProps = {
    list: [
      {
        type: "perk",
        value: "High number of direct applies"
      },
      {
        type: "perk",
        value: "High number of database matches"
      },
      {
        type: "perk",
        value: "Increased job reach"
      },
      {
        type: "perk",
        value: "Get noticed by an urgent hiring tag"
      }
      // { type: "perk", value: "Get one job boost for free - limited time offer" }
    ]
  };

  return (
    <PremiumPopup
      heading={heading}
      open={isPopupOpen}
      subHeading={popupSubHeading}
      onClose={onClose}
      cityId={cityId}
      categoryId={categoryId}
      perksDrawbackList={perksDrawbackList}
      renderButtons={() => {
        return (
          <ButtonGroup>
            <PostJobView
              classes="w-full"
              jobPlan={PREMIUM_JOB}
              successCallback={callback}
            >
              Post a {premiumJobLabel}
            </PostJobView>
          </ButtonGroup>
        );
      }}
    />
  );
};
export default PostPremiumJob;
